import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";

export default class PaymentReminderErrorResponse extends ApiErrorResponse {
    static defaultResponse() {
        return {
            object: {},
            errors: [
                {
                    'code': 'blank_payment_reminder_message_error',
                    'text': 'Payment reminder message cannot be blank'
                }
            ]
        }
    }

    static errorCodes() {
        return [
            'blank_payment_reminder_message_error',
            'customer_without_collections_email_error',
            'customer_without_overdue_invoices_error',
            'payment_reminder_without_selected_invoices_error',
            'invoice_is_not_an_overdue_invoice_of_customer_error',
        ];
    }
}
